module.exports = __webpack_public_path__ + "static/media/cu.99a0d2a0.svg";